import { noAuthAxios } from "./api"

export const QUERY_KEY = "events"
export const BASE_URL = "app/events/"

export const listEvents = () => noAuthAxios.get(BASE_URL + "?page_size=150")

